export enum RepetitionType {
  NO_REPETITION = 'NO_REPETITION',
  EVERY_DAY = 'EVERY_DAY',
  EVERY_WEEK = 'EVERY_WEEK',
  EVERY_OTHER_WEEK = 'EVERY_OTHER_WEEK',
}
